import React, { useMemo } from 'react';
import { OrderStatus } from '~/types/Order';
import { formatCurrency } from '~/utils/currency';

import i18n from '~/i18n';
import { useNavigate } from 'react-router-dom';
import { Order } from '@restaurant/api';
import { ORDER_TYPE_TEXT, PAYMENT_METHOD_TEXT } from '@restaurant/constants';
import { formatTime } from '~/utils/time';

const OrderHistoryItemRow = ({ order }: { order: Order }) => {
  const typeText = ORDER_TYPE_TEXT[order.orderType];

  const title = useMemo(() => {
    const arr = [
      typeText,
      order.tableNumber
        ? i18n.t('order_info_table_no', { no: order.tableNumber })
        : null,
      order.customerName,
    ]
      .filter((val) => val)
      .join(' - ');

    if (order.status !== OrderStatus.Closed) {
      return `[${order.status}] ` + arr;
    }
    return arr;
  }, [order]);

  const navigate = useNavigate();

  const onClick = () => {
    navigate(`${order.orderId}`);
  };

  const paymentText = order.payment
    ? `${PAYMENT_METHOD_TEXT[order.payment.method]} - Waktu bayar ${formatTime(
        order.payment.timestamp
      )}`
    : '-';

  return (
    <div
      className="w-full cursor-pointer py-2 px-4"
      style={{ borderBottom: '1px solid #eee' }}
      onClick={onClick}
    >
      <div className="flex justify-between items-center text-xs text-neutral-500">
        <p>{`No: ${order.orderNumber}`}</p>
        <p>{`Created at ${formatTime(order.dateCreated)}`}</p>
      </div>
      <div className="flex justify-between items-center">
        <p className="text-base font-medium">{title}</p>
      </div>
      <div className="flex justify-between items-center">
        <p>{paymentText}</p>
        <p>{formatCurrency(order.totalPrice)}</p>
      </div>
    </div>
  );
};

export default OrderHistoryItemRow;
